module.exports = __webpack_public_path__ + "static/media/elk.7bed0973.avif";